import Link from 'next/link'
import Box from '../UI/box/Box'
import Typography from '../UI/typography/Typography'
import LoginContainer from '../reusable/loginContainer/LoginContainer'
import styles from './Login.module.scss'
import { useRouter } from 'next/router'

const Login = () => {
  const router = useRouter()
  const nextUrl = router.query?.next_url as string | undefined

  const handleLogin = () => {
    const path = nextUrl ? `${window.location.origin}/${nextUrl}` : '/'
    router.replace(path)
  }

  return (
    <Box className={styles['login-container']}>
      <Box className={styles['login-content']}>
        <LoginContainer onLogin={handleLogin} />
      </Box>
      <Box className={styles['back-to-home']}>
        <Typography variant="bodyS" color="neutral_700">
          قصد ورود و مشاهده صفحه را ندارید؟
        </Typography>
        <Link href="/">
          <Typography variant="bodyS" color="primary_main">
            مشاهده صفحه اصلی
          </Typography>
        </Link>
      </Box>
    </Box>
  )
}

export default Login
